import { render } from "./UpdatePassword.vue?vue&type=template&id=0eaeecbd&scoped=true"
import script from "./UpdatePassword.vue?vue&type=script&lang=js"
export * from "./UpdatePassword.vue?vue&type=script&lang=js"

import "./UpdatePassword.vue?vue&type=style&index=0&id=0eaeecbd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eaeecbd"]])

export default __exports__